import {Component, input} from '@angular/core';
import {ProgressBar} from 'primeng/progressbar';

@Component({
  selector: 'app-progress-bar',
  imports: [ProgressBar],
  templateUrl: './progress-bar.component.html',
})
export class ProgressBarComponent {
  readonly completed = input(0);
  readonly total = input(0);
  readonly label = input('');
  readonly testIdInfo = input('generic-progress-info');
  readonly testIdBar = input('generic-progress-bar');

  calcPercentage(): number {
    return this.total() > 0 ? Math.floor((this.completed() / this.total()) * 100) : 0;
  }
}
